import * as React from "react";
import Render from "../../Shared/Render";
import { ExpandedDisplayItems } from "./ExpandedDisplayItems";
import { IBottomBarRenderProps } from "./IBottomBarRenderProps";
import { QuickJournal } from "../QuickJournal/QuickJournal";
import { GetQuickJournalTheme } from "../QuickJournal/View/QuickJournalTheme";
import { useQuickJournalDuneAnimationPause } from "../QuickJournal/Hooks/useQuickJournalDuneAnimationPause";
import { QuickJournalDuneSunlightSlits } from "../QuickJournal/View/Backdrop/QuickJournalDuneSunlightSlits";
import { QuickJournalDuneDustParticles } from "../QuickJournal/View/Backdrop/QuickJournalDuneDustParticles";
import { QuickJournalChromaFlare } from "../QuickJournal/View/Backdrop/QuickJournalChromaFlare";
import { QuickJournalLowerAmbience } from "../QuickJournal/View/Backdrop/QuickJournalLowerAmbience";

export function QuickJournalOverlay({ state, isClosingQuickJournal, onKeyboardFocusChange,
    onEntrySubmitted, onRecentEntriesChange, onCloseQuickJournal, shouldHideLowerControls,
}: IBottomBarRenderProps & { shouldHideLowerControls: boolean }) {
    const quickJournalTheme = GetQuickJournalTheme(state.quickJournalThemeName);
    const isChromaFlare = quickJournalTheme.id === "chromaflare";
    const shouldShowDuneHeatMirage = quickJournalTheme.id === "dune";
    const areQuickJournalBackdropAnimationsPaused = useQuickJournalDuneAnimationPause(isClosingQuickJournal);
    return (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        display: "flex",
                        flexDirection: "column",
                        zIndex: 20000,
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            position: "relative",
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: isChromaFlare ? quickJournalTheme.overlay.backgroundColor : undefined,
                            backgroundImage: isChromaFlare ? quickJournalTheme.overlay.backgroundImage : undefined,
                        }}
                    >
                        <div
                            style={{
                                flex: 1,
                                minWidth: 0,
                                position: "relative",
                                backgroundColor:
                                    isChromaFlare ? "transparent" : quickJournalTheme.overlay.backgroundColor,
                                backgroundImage:
                                    isChromaFlare ? "none" : quickJournalTheme.overlay.backgroundImage,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                            }}
                        >
                        </div>
                        <div
                            style={{
                                flex: 1,
                                minWidth: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "stretch",
                                justifyContent: "flex-end",
                                position: "relative",
                                backgroundColor:
                                    isChromaFlare ? "transparent" : quickJournalTheme.overlay.backgroundColor,
                                backgroundImage:
                                    isChromaFlare ? "none" : quickJournalTheme.overlay.backgroundImage,
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "100% 100%",
                            }}
                        >
                            <QuickJournal
                                keyboardOffsetY={0}
                                themeName={state.quickJournalThemeName}
                                onKeyboardFocusChange={onKeyboardFocusChange}
                                onEntrySubmitted={onEntrySubmitted}
                                onRecentEntriesChange={onRecentEntriesChange}
                            />
                        </div>
                        {quickJournalTheme.id === "chromaflare" && <QuickJournalChromaFlare upper isPaused={areQuickJournalBackdropAnimationsPaused} />}
                        <Render
                            id="quickJournalDuneSunlightSlits"
                            when={shouldShowDuneHeatMirage}
                        >
                            <QuickJournalDuneSunlightSlits
                                isPaused={areQuickJournalBackdropAnimationsPaused}
                            />
                        </Render>
                        <Render
                            id="quickJournalDuneDustParticles"
                            when={shouldShowDuneHeatMirage}
                        >
                            <QuickJournalDuneDustParticles
                                isPaused={areQuickJournalBackdropAnimationsPaused}
                            />
                        </Render>
                    </div>
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            position: "relative",
                            paddingTop: "20px",
                            backgroundColor:
                                quickJournalTheme.backdrop.backgroundColor,
                            backgroundImage:
                                quickJournalTheme.backdrop.background,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "100% 100%",
                            boxShadow: quickJournalTheme.backdrop.boxShadow,
                        }}
                    >
                        <QuickJournalLowerAmbience theme={quickJournalTheme} isPaused={areQuickJournalBackdropAnimationsPaused} />
                        <ExpandedDisplayItems
                            displayLarge={state.showQuickJournal}
                            hideGameOptions={shouldHideLowerControls}
                            keyboardOffsetY={0}
                            onCloseQuickJournal={onCloseQuickJournal}
                        />
                    </div>
                </div>
    );
}
